export const noop = () => {}
export type Maybe<T> = T | null

export * from './castTouchToMouseEvent'
export * from './detectMouseButton'
export * from './doObjectsCollide'
export * from './getBoundsForNode'
export * from './nodeInRoot'
